import useSpotifyAlbumsData from "hooks/useSpotifyAlbumsData";
import useSpotifyAPI from "hooks/useSpotifyAPI";
import useSpotifyTracksData from "hooks/useSpotifyTracksData";
import { createContext, useRef,useState } from "react";

export const UserContext = createContext();

export function UserContextProvider({ children }) {
  //   User Info
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [isDoingAnotherScore, setIsDoingAnotherScore] = useState(false);

  //   User Selections and Inputs
  const [searched, setSearched] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState({
    mainArtist: "",
    id: 0,
    img: "",
    url: "",
    name: "",
  });
  const [searchQuery, setSearchQuery] = useState("");

  const [currentRatings, setCurrentRatings] = useState({});
  const [selectedScoreType, setSelectedScoreType] = useState("");
  const [favSongs, setFavSongs] = useState([]);

  // Btns
  const [currentStep, setCurrentStep] = useState(0);

  // Calculations and results for User
  const [connectionScore, setConnectionScore] = useState(0);
  const shareableImgRef = useRef();

  // new new
  const [albumsLoading, setAlbumsLoading] = useState(false);

  const accessToken = useSpotifyAPI();

  const albumsRequestUrl = `https://api.spotify.com/v1/search?q=${searchQuery}&type=album&limit=50`;

  const albumTracksRequestUrl = `https://api.spotify.com/v1/albums/${selectedAlbum?.id}/tracks?include_groups=album&market=US&limit=50`;

  const { albums, setAlbums } = useSpotifyAlbumsData(
    accessToken,
    albumsRequestUrl,
    searchQuery,
    setAlbumsLoading
  );

  const { albumTracks, setAlbumTracks } = useSpotifyTracksData(
    accessToken,
    albumTracksRequestUrl,
    selectedAlbum?.id,
  );

  const handleResetData = () => {
    setSearched(false);
    setAlbums([]);
    setAlbumTracks([]);
    setSelectedAlbum({});
    setSearchQuery("");

    setSelectedScoreType("");
    setCurrentRatings({});
    setFavSongs([]);
    setConnectionScore(0);

    setIsDoingAnotherScore(true);
  };

  // Values
  const val = {
    user,
    setUser,
    isDoingAnotherScore,
    setIsDoingAnotherScore,
    searched,
    setSearched,   
    selectedAlbum,
    setSelectedAlbum,
    searchQuery,
    setSearchQuery,    
    currentRatings,
    setCurrentRatings,
    selectedScoreType,
    setSelectedScoreType,
    favSongs,
    setFavSongs,
    currentStep,
    setCurrentStep,
    connectionScore,
    setConnectionScore,
    shareableImgRef,
    albumsLoading,
    setAlbumsLoading,
    albums,
    setAlbums,
    albumTracks,
    setAlbumTracks,
    handleResetData,
  };

  return <UserContext.Provider value={val}>{children}</UserContext.Provider>;
}
